import ZoneId from '../../../../../resources/zone_id';
import { RaidbossData } from '../../../../../types/data';
import { TriggerSet } from '../../../../../types/trigger';

export type Data = RaidbossData;

const triggerSet: TriggerSet<Data> = {
  id: 'AacCruiserweightM3',
  zoneId: ZoneId.AacCruiserweightM3,
  timelineFile: 'r7n.txt',
  triggers: [],
};

export default triggerSet;
